export const companiesCompanyIdCustomDomainsDomainTypeDomainId =
  "/companies/:company_id/custom_domains/:domain_type/:domain_id";
